import { defineMessages } from 'react-intl';

export default defineMessages({
  home: {
    id: 'home',
    defaultMessage: 'Home',
  },
  orderList: {
    id: 'orderlist',
    defaultMessage: 'Order List',
  },
  btn: {
    downloadCSV: {
      id: 'orderlist.btn.downloadCSV',
      defaultMessage: 'Download as .csv',
    },
  },
  header: {
    no: {
      id: 'orderlist.header.no',
      defaultMessage: 'No',
    },
    orderId: {
      id: 'orderlist.header.orderId',
      defaultMessage: 'Order Id',
    },
    source: {
      id: 'orderlist.header.source',
      defaultMessage: 'Source',
    },
    publicId: {
      id: 'orderlist.header.publicId',
      defaultMessage: 'Public Id',
    },
    acquirementId: {
      id: 'orderlist.header.acquirementId',
      defaultMessage: 'Acquirement Id',
    },
    senderName: {
      id: 'orderlist.header.senderName',
      defaultMessage: 'Sender Name',
    },
    phoneNumber: {
      id: 'orderlist.header.phoneNumber',
      defaultMessage: 'Phone Number',
    },
    courierBy: {
      id: 'orderlist.header.courierBy',
      defaultMessage: 'Courier By',
    },
    partnerDeliveryId: {
      id: 'orderlist.header.partnerDeliveryId',
      defaultMessage: 'AWB',
    },
    orderTime: {
      id: 'orderlist.header.orderTime',
      defaultMessage: 'Order Timestamp',
    },
    status: {
      id: 'orderlist.header.status',
      defaultMessage: 'Status',
    },
  },
  status: {
    initTrans: {
      id: 'orderStatus.init_trans',
      defaultMessage: 'Processing order',
    },
    payAcquired: {
      id: 'orderStatus.pay_acquired',
      defaultMessage: 'Payment received',
    },
    deliveryOrderCreated: {
      id: 'orderStatus.delivery_order_activated',
      defaultMessage: 'Creating order',
    },
    requestForPickup: {
      id: 'orderStatus.request_for_pickup',
      defaultMessage: 'Requesting pickup',
    },
    searchForDriver: {
      id: 'orderStatus.search_for_driver',
      defaultMessage: 'Searching for courier',
    },
    driverEnroute: {
      id: 'orderStatus.driver_enroute',
      defaultMessage: 'Waiting for pickup',
    },
    cancelledByUser: {
      id: 'orderStatus.cancelled_by_user',
      defaultMessage: 'Cancelled by User',
    },
    cancelledBySystem: {
      id: 'orderStatus.cancelled_by_system',
      defaultMessage: 'Cancelled by System',
    },
    cancelledByPartner: {
      id: 'orderStatus.cancelled_by_partner',
      defaultMessage: 'Cancelled by Partner',
    },
    pickupRejected: {
      id: 'orderStatus.pickup_rejected',
      defaultMessage: 'Pickup rejected',
    },
    pickupCancelled: {
      id: 'orderStatus.pickup_cancelled',
      defaultMessage: 'Pickup cancelled',
    },
    packagePickedUp: {
      id: 'orderStatus.package_picked_up',
      defaultMessage: 'Package picked Up',
    },
    packageInDelivery: {
      id: 'orderStatus.package_in_delivery',
      defaultMessage: 'Delivering package',
    },
    packageArrived: {
      id: 'orderStatus.package_arrived',
      defaultMessage: 'Package delivered',
    },
    deliveryOrderReturned: {
      id: 'orderStatus.delivery_order_returned',
      defaultMessage: 'Refund successful',
    },
    cancelFailed: {
      id: 'orderStatus.cancel_failed',
      defaultMessage: 'Cancel failed',
    },
    cancelSuccess: {
      id: 'orderStatus.cancel_success',
      defaultMessage: 'Cancel success',
    },
    orderTransit: {
      id: 'orderStatus.package_in_transit',
      defaultMessage: 'Package in transit',
    },
    orderReturn: {
      id: 'orderStatus.package_in_return',
      defaultMessage: 'Package in return',
    },
    orderExpired: {
      id: 'orderStatus.order_expired',
      defaultMessage: 'Order Expired',
    },
  },
});
